import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="fixed w-full z-50 top-0" style={{ background: 'rgba(8,35,24,0.85)', backdropFilter: 'blur(16px)', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
      <div className="max-w-[1280px] mx-auto px-6 py-4 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2.5 hover:opacity-80 transition">
          <img src="/assets/synex.png" alt="Synex Agency" className="h-9 w-auto" />
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-10 text-sm font-medium text-white/75">
          <Link to="/about" className="hover:text-white transition duration-200">About</Link>
          <Link to="/projects" className="hover:text-white transition duration-200">Case Study</Link>
          <Link to="/#services" className="hover:text-white transition duration-200">Services</Link>
          <Link to="/#pricing" className="hover:text-white transition duration-200">Pricing</Link>
        </div>

        {/* CTA */}
        <div className="flex items-center gap-4">
          <Link
            to="/contact"
            className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 bg-brand text-surface font-semibold text-sm rounded-lg hover:bg-brand-dark transition duration-200 shadow-lg shadow-brand/20"
          >
            Get a Quick Demo
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2 12L12 2M12 2H5M12 2v7"/>
            </svg>
          </Link>
          {/* Mobile hamburger */}
          <button
            className="md:hidden p-2 text-white/70 hover:text-white transition"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            {menuOpen ? (
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="4" y1="4" x2="18" y2="18"/><line x1="18" y1="4" x2="4" y2="18"/></svg>
            ) : (
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="7" x2="19" y2="7"/><line x1="3" y1="13" x2="19" y2="13"/></svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden px-6 pb-6 flex flex-col gap-5 text-white/80 text-sm font-medium border-t border-white/10 pt-4">
          <Link to="/about" onClick={() => setMenuOpen(false)} className="hover:text-white transition">About</Link>
          <Link to="/projects" onClick={() => setMenuOpen(false)} className="hover:text-white transition">Case Study</Link>
          <Link to="/#services" onClick={() => setMenuOpen(false)} className="hover:text-white transition">Services</Link>
          <Link to="/#pricing" onClick={() => setMenuOpen(false)} className="hover:text-white transition">Pricing</Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)} className="inline-flex items-center gap-2 px-5 py-2.5 bg-brand text-surface font-semibold text-sm rounded-lg w-fit">
            Get a Quick Demo ↗
          </Link>
        </div>
      )}
    </nav>
  );
}
